import { render, staticRenderFns } from "./PersonalInformation.vue?vue&type=template&id=0c0a29c2&"
import script from "./PersonalInformation.vue?vue&type=script&lang=js&"
export * from "./PersonalInformation.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/fared/kowamas-frontend/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('0c0a29c2')) {
      api.createRecord('0c0a29c2', component.options)
    } else {
      api.reload('0c0a29c2', component.options)
    }
    module.hot.accept("./PersonalInformation.vue?vue&type=template&id=0c0a29c2&", function () {
      api.rerender('0c0a29c2', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/view/pages/profile/profile-comp/PersonalInformation.vue"
export default component.exports